import Vue from 'vue'
import "./common/init"
import App from './App.vue'
import plugin from "./plugin/index";
import axios from "./common/req";
import router from './router'
import store from './store'
import form from "./form/index"

Vue.use(plugin);
Vue.use(form);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

document.body.addEventListener('touchmove', function(e) {
  if(!e._isScroller) {
    e.preventDefault();
  }
}, {passive: false});
